import { render } from "./ConfModalHead.vue?vue&type=template&id=5cf0e9ce"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__